import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import { BiTrash } from 'react-icons/bi'
import { VscDiffAdded } from 'react-icons/vsc'
import allowNumbersOnly, { handlePaste } from '../../../CommonUtils/CommonValidations'
import * as Yup from 'yup'
import * as bie from "react-bootstrap";
import moment from 'moment'
import { GetMediumList } from '../../../Reducers/AffiliationCommonservice'
import { useSelector } from 'react-redux'
import { ImagePdfBucket } from '../../../CommonUtils/ImagesBase64'
import { ERROR_MSG } from '../../../CommonUtils/contextVariables'
import { viewImage } from '../../../CommonUtils/viewImage'
import { BsEye } from 'react-icons/bs'
import { failureAlert, successAlert2 } from '../../../CommonUtils/SweetAlerts'
import { useNavigate } from 'react-router-dom'

export default function ApproveAddCourses() {
    const MediumData = useSelector((state) => state?.commonMastersReducer?.Medium);
    const hasFetchedData = useRef(false);
    let navigate = useNavigate();
    function navigateTabs() {
        navigate("/AffiliationCollegeCourseDetails2021");
    }
    const validation = Yup.object({
        afflPdf: Yup.string().required(ERROR_MSG).nullable(),
        courses: Yup.array().of(
            Yup.object().shape({
                instType: Yup.string().required(ERROR_MSG).nullable(),
                courseType: Yup.string().required(ERROR_MSG).nullable(),
                courseId: Yup.string().required(ERROR_MSG).nullable(),
                mediumCode: Yup.string().required(ERROR_MSG).nullable(),
                regSelf: Yup.string().required(ERROR_MSG).nullable(),
                courseAfflType: Yup.string().required(ERROR_MSG).nullable(),
                finalSanctionIntake: Yup.string().required(ERROR_MSG).nullable(),
                afflValidUpto: Yup.string().required(ERROR_MSG).nullable(),
                campusType: Yup.string().required(ERROR_MSG).nullable(),
            })
        )

    });

    const formik = useFormik({
        initialValues: {
            noOfCourses: '1',
            afflPdf: '',
            courses: [{
                instType: '',
                courseType: '',
                courseId: '',
                mediumCode: '',
                regSelf: '',
                courseAfflType: '',
                afflValidUpto: '',
                finalSanctionIntake: '',
                campusType: '',
            }]
        },
        validationSchema: validation,
        onSubmit: (val) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `AddingNewRenewalCourseDetails`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc)
                            GetApprovedAddCourseData();
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            })
        }
    })
    const [program, setProgram] = useState([]);

    function GetProgram() {
        let url = config.url.API_URL + `getCourseGroupList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setProgram(res?.data?.getCourseGroupList)
            }
            else {
                setProgram([])
            }
        })
    }


    const [CourseCategory, setCourseCategory] = useState([]);
    function GetCourseCategory(prgm, index) {
        try {
            if (!prgm) {
                console.error('CourseCategory is not valid.');
                return;
            }

            let url = config.url.API_URL + `getCourseCategoryList/${prgm}`
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    let options = res?.data?.getCourseCategoryList?.map((ds, i) => {
                        return (
                            <option key={i} value={ds.course_cat_id}>{ds.course_cat_name}</option>
                        );
                    });
                    setCourseCategory((prevState) => ({
                        ...prevState,
                        [index]: options,
                    }));


                }
                else {
                    setCourseCategory((prevState) => ({
                        ...prevState,
                        [index]: [],
                    }));
                }
            })
        } catch (err) {
            console.log("Error in getting Course Categoty", err)
        }
    }

    const [course, setCourse] = useState([]);
    function GetCourses(CourseCat, index) {
        try {
            if (!CourseCat) {
                console.error('CourseCategory is not valid.');
                return;
            }

            let url = config.url.API_URL + `getSpecilization/${CourseCat}`;
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    let options = res?.data?.Specilization?.map((ds, i) => {
                        return (
                            <option key={i} value={ds.course_id}>{ds.course_name}</option>
                        );
                    });
                    setCourse((prevState) => ({
                        ...prevState,
                        [index]: options,
                    }));


                } else {
                    setCourse((prevState) => ({
                        ...prevState,
                        [index]: [],
                    }));
                }
            });
        } catch (err) {
            console.error('Error in GetCourses function:', err);
        }
    }

    const [approvalproccedingpdf, setapprovalproccedingpdf] = useState('');
    function GetApprovedAddCourseData() {
        let url = config.url.API_URL + `getAddingNewRenewalCourseDetails`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setapprovalproccedingpdf(res?.data?.order);
                formik?.setFieldValue(`afflPdf`, res?.data?.order || '');
                formik?.setFieldValue("noOfCourses", res?.data?.course.length)
                res?.data?.course?.forEach((data, i) => {
                    const AfflValidUpto = data?.affl_valid_upto && moment(data?.affl_valid_upto,
                        'DD/MM/YYYY', true).isValid() ? moment(data?.affl_valid_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                    formik?.setFieldValue(`courses[${i}].instType`, data?.inst_type);
                    GetCourseCategory(data?.inst_type, i);
                    formik?.setFieldValue(`courses[${i}].courseType`, data?.course_cat_id);
                    GetCourses(data?.course_cat_id, i);
                    formik?.setFieldValue(`courses[${i}].courseId`, data?.course_id);

                    formik?.setFieldValue(`courses[${i}].mediumCode`, data?.medium_code);
                    formik?.setFieldValue(`courses[${i}].regSelf`, data?.reg_self);
                    formik?.setFieldValue(`courses[${i}].courseAfflType`, data?.course_affl_type);
                    formik?.setFieldValue(`courses[${i}].finalSanctionIntake`, data?.final_sanction_intake);
                    formik?.setFieldValue(`courses[${i}].afflValidUpto`, AfflValidUpto ?? '');
                    formik?.setFieldValue(`courses[${i}].campusType`, data?.campus_type);

                })

            }
            else {
                setapprovalproccedingpdf('');
            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetApprovedAddCourseData();
            GetProgram();
            GetMediumList();
            hasFetchedData.current = true
        }
    }, [])

    function Deleteindex(coursevalues, index) {
        const updatedCourseCategory = { ...CourseCategory };
        delete updatedCourseCategory[index];

        const rearrangeCourseType = Object.values(updatedCourseCategory).reduce((acc, item, index) => {
            acc[index] = item;
            return acc;
        }, {});

        setCourseCategory(rearrangeCourseType);

        //course, setCourse
        const updatedCourse = { ...course };
        delete updatedCourse[index];//1//

        const rearrangeCourse = Object.values(updatedCourse).reduce((acc, item, index) => {
            acc[index] = item;
            return acc;
        }, {});

        setCourse(rearrangeCourse)


        coursevalues.remove(index);
        formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1)

    }


    return (
        <bie.Container fluid className="px-1" >
            <bie.Row>
                <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="">
                    <div className="inner-herbpage-service-title1">
                        <h1>Add Courses Approved in EC Meeting and Missing in CDC Dean Login</h1>
                    </div>
                </bie.Col>
            </bie.Row>

            <div className='form-control p-3'>
                <FormikProvider value={formik}>
                    <bie.Row className="mb-3">
                        <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                style={{ float: "right" }}
                                onClick={navigateTabs}>
                                Back
                            </button>
                        </bie.Col>
                    </bie.Row>
                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}>
                        <div style={{ display: 'flex', alignItems: 'center' }} className='form-control mb-2'>

                            <label className='mb-1' style={{ marginRight: '10px', fontWeight: 'bold' }} ><b className='field-mandatory'>Upload Competent Authority Approval or Proceedings</b><b style={{ color: 'red' }}>* </b></label>
                            <input type="file" name="afflPdf" className="form-control " style={{ width: "350px" }} accept="application/pdf"
                                onChange={(e) => {
                                    let filename = `afflPdf`;
                                    let path = "/Uploads/Affiliation2023/";
                                    ImagePdfBucket(e, formik, path, `afflPdf`, filename, "pdf");
                                }}
                            /> &emsp;
                            {approvalproccedingpdf && (
                                <button type="button" onClick={() => viewImage(approvalproccedingpdf)} className="btn btn-primary btn-sm"><BsEye className="fs-10" /></button>)
                            }
                            <ErrorMessage name="afflPdf" component="div" className="text-error" />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }} className='form-control mb-2'>
                            <label className='mb-1' style={{ marginRight: '10px', fontWeight: 'bold' }}>
                                No.of Courses  :
                            </label>
                            <Field type='text' name='noOfCourses' className='form-control mb-2' style={{ width: 'auto' }} disabled></Field></div>

                        <div className="table-responsive mt-3">
                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>SNO</th>
                                        <th>Academic Program Type</th>
                                        <th>Course /Program</th>
                                        <th>Branch /Combination</th>
                                        <th>Medium</th>
                                        <th>Regular/Self-Financed</th>
                                        <th>Afiliation Permanent/Temporary</th>
                                        <th>Approved Intake</th>
                                        <th>Date of Approval By University/APSCHE</th>
                                        <th>Campus Type</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <FieldArray name="courses">
                                        {(coursevalues) => (
                                            coursevalues?.form?.values?.courses.map((exp, index) => (
                                                <tr key={index}>
                                                    <td><center>{index + 1}</center></td>
                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].instType`}

                                                            onChange={(e) => {

                                                                const selectedValue = e.target.value;
                                                                GetCourseCategory(selectedValue, index);
                                                                formik.setFieldValue(`courses[${index}].courseType`, "");
                                                                formik.setFieldValue(`courses[${index}].courseId`, "");
                                                                // Reset dependent fields if no selection
                                                                if (!selectedValue) {

                                                                    setCourseCategory((prevState) => ({
                                                                        ...prevState,
                                                                        [index]: [],
                                                                    }));
                                                                    setCourse((prevState) => ({
                                                                        ...prevState,
                                                                        [index]: [],
                                                                    }));

                                                                }
                                                            }}>
                                                            <option value=''>--SELECT--</option>
                                                            {program && program?.map((pp, i) => (
                                                                <option value={pp?.course_group_code} key={i}>{pp?.course_group_desc}</option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].instType`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].courseType`}
                                                            tyle={{ width: "8rem" }}
                                                            //  onChange={(e) => {
                                                            //     GetCourses(e.target.value, index);
                                                            //     formik.setFieldValue(`courses[${index}].courseId`, "");

                                                            // }}>

                                                            onChange={(e) => {
                                                                const selectedValue = e.target.value;
                                                                if (!selectedValue) {

                                                                    setCourse((prevState) => ({
                                                                        ...prevState,
                                                                        [index]: [],
                                                                    }));

                                                                }
                                                                GetCourses(e.target.value, index);
                                                                formik.setFieldValue(`courses[${index}].courseId`, "");


                                                            }}>
                                                            <option value="">--select--</option>
                                                            {CourseCategory[index]}

                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].courseType`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].courseId`} style={{ width: "8rem" }}>
                                                            <option value="">--select--</option>
                                                            {course[index]}

                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].courseId`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].mediumCode`}>
                                                            <option value=''>--SELECT--</option>
                                                            {MediumData && MediumData?.map((rel, i) => (
                                                                <option value={rel?.medium_code}>{rel?.name}</option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].mediumCode`} component="div" className="text-error" />
                                                    </td>

                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].regSelf`}>
                                                            <option value="">--SELECT--</option>
                                                            <option value="R">Regular</option>
                                                            <option value="S">Self-Financed</option>
                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].regSelf`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].courseAfflType`}>
                                                            <option value="">--SELECT--</option>
                                                            <option value="Permanent">Permanent</option>
                                                            <option value="Temporary">Temporary</option>
                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].courseAfflType`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field type="text" className="form-control mb-2" name={`courses[${index}].finalSanctionIntake`} maxLength='4' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                                        <ErrorMessage name={`courses[${index}].finalSanctionIntake`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field type="date" className="form-control mb-2" name={`courses[${index}].afflValidUpto`}
                                                            min="1970-01-01"
                                                            max={new Date().toISOString().split("T")[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                                        <ErrorMessage name={`courses[${index}].afflValidUpto`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control mb-2" name={`courses[${index}].campusType`}>
                                                            <option value="">--Select--</option>
                                                            <option value="main">Main Campus</option>
                                                            <option value="off">Off Campus</option>
                                                        </Field>
                                                        <ErrorMessage name={`courses[${index}].campusType`} component="div" className="text-error" />
                                                    </td>
                                                    <td align="center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="button-titile btn btn-sm btn-success"
                                                                onClick={() => {
                                                                    formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) + 1)
                                                                    coursevalues.push({
                                                                        afflValidUpto: '',
                                                                        finalSanctionIntake: '',
                                                                        instType: '',
                                                                        courseType: '',
                                                                        courseId: '',
                                                                        regSelf: '',
                                                                        mediumCode: '',
                                                                        courseAfflType: '',
                                                                        campusType: ''
                                                                    });
                                                                }}
                                                            >
                                                                <VscDiffAdded></VscDiffAdded>{" "}
                                                            </button>
                                                        ) : ""}
                                                        {index !== 0 ? (
                                                            <button type="button" className="button-titile btn btn-sm btn-danger"
                                                                onClick={() => {
                                                                    // coursevalues.remove(index);
                                                                    Deleteindex(coursevalues, index)
                                                                    // formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1)
                                                                }}>
                                                                <BiTrash></BiTrash>
                                                            </button>
                                                        ) : ""}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </FieldArray>
                                </tbody>
                            </table>
                        </div>
                        <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />
                    </Form></FormikProvider></div></bie.Container>
    )
}
